module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/7572bo/master/~/vue-loader/lib/template-compiler?{"id":"data-v-7d2f3dfc"}!F:/Solutions/7572bo/master/~/vue-loader/lib/selector.js?type=template&index=0!F:/Solutions/7572bo/master/~/vue2-google-maps/dist/components/autocomplete.vue
// module id = 272
// module chunks = 1